import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";

interface TeamMember {
  name: string;
  role: string[];
  image: string;
  linkedin: string;
}

interface TeamSectionProps {}

const TeamSection = ({}: TeamSectionProps) => {
  const teamMembers: TeamMember[] = [
    {
      name: "Ben-Lior Ilis",
      role: ["Founder", "Board of Director"],
      image: "/lovable-uploads/fe7b2da8-c837-49ee-83f3-4ac9b9a9898c.png",
      linkedin: "https://www.linkedin.com/in/lior-ilis/"
    },
    {
      name: "Manuel Graber",
      role: ["CTO"],
      image: "/lovable-uploads/347bc323-cc92-4e4d-b5b8-5e74089eecd8.png",
      linkedin: "https://www.linkedin.com/in/manuel-graber/"
    },
    {
      name: "Philipp Richner",
      role: ["CFO"],
      image: "/lovable-uploads/abe12bfd-02ac-4a95-bd45-683d63a895b3.png",
      linkedin: "https://www.linkedin.com/in/philipp-richner-2b0b82a5/"
    },
    {
      name: "Laura Gadret",
      role: ["CMO"],
      image: "/lovable-uploads/f02bb6e2-ce04-4b68-92e2-54483e221c11.png",
      linkedin: "https://www.linkedin.com/in/laura-gedrat/"
    },
    {
      name: "Jesper Bentzen",
      role: ["CSO"],
      image: "/lovable-uploads/0a5cdde2-4471-499a-a19b-69e98ed24656.png",
      linkedin: "https://www.linkedin.com/in/jesper-bentzen/"
    },
    {
      name: "Marco Eismann",
      role: ["Relations Officer"],
      image: "/lovable-uploads/b889e4a4-084d-483f-ba47-dd5cb9f83ae7.png",
      linkedin: "https://www.linkedin.com/in/marco-eismann-5782ba257/"
    }
  ];

  return (
    <section className="px-4 py-16 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-3 text-corporate-primary-100">Our Team</h2>
        <div className="w-24 h-1 bg-corporate-secondary-100 mx-auto mb-6"></div>
        <p className="text-corporate-neutral-75 mb-12 text-lg max-w-2xl mx-auto">
          We're a diverse group of innovators, technologists, and finance professionals 
          with a shared passion for redefining the trading landscape.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-corporate-primary-25 group"
            >
              <div className="w-32 h-32 rounded-full overflow-hidden mx-auto mb-4 border-4 border-corporate-primary-25 group-hover:border-corporate-secondary-75 transition-colors duration-300">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full h-full object-cover" 
                />
              </div>
              <h3 className="font-semibold mb-1 text-lg text-corporate-primary-100">{member.name}</h3>
              <div className="text-sm text-corporate-neutral-75">
                {member.role.map((role, roleIndex) => (
                  <p key={roleIndex}>{role}</p>
                ))}
              </div> 
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-corporate-primary-100 hover:text-corporate-secondary-100 transition-colors duration-300"
              >
                <Linkedin className="w-6 h-6 mx-auto" />
              </a>

            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
